if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if(!this.form) return;

        const variantInput = this.form.querySelector('[name=id]');
        if(variantInput) variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      triggerFlyToCartAnimation() {
        const cartIcon = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart') || document.querySelector('.cart-count-bubble');

        const productCard = this.closest('.card-wrapper') || this.closest('.product') || this.closest('.quick-add-modal__content');

        const productImage = productCard ? productCard.querySelector('img') : document.querySelector('.product__media img');

        if (cartIcon && this.submitButton && productImage) {
          const flyer = document.createElement('fly-to-cart');
          flyer.source = this.submitButton;
          flyer.destination = cartIcon;
          
          const imgSource = productImage.currentSrc || productImage.src;
          flyer.style.setProperty('background-image', `url(${imgSource})`);
          
          document.body.appendChild(flyer);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();


        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // custom code start

        this.productWrapper = this.closest('.product-main-info-wrapper');
        if (this.productWrapper) {
          this.fbtProducts = this.productWrapper.querySelectorAll('.fbt-checkbox');
        
          if (this.fbtProducts && this.productWrapper) {

            const mainVariantId = formData.get('id');
            const mainQty = parseInt(formData.get('quantity') || 1);
            const mainInventory = parseInt(this.productWrapper.querySelector('.quantity__rules-cart .rule-span').dataset.limit) || null;
            const mainCartQty = parseInt(this.productWrapper.querySelector('.quantity__rules-cart .rule-span').dataset.cart) || null;
            const totalRequested = mainQty + mainCartQty;
            if (totalRequested > mainInventory) {
              this.handleErrorMessage(
                `Only ${mainInventory} items available. You already have ${mainCartQty} in cart.`
              );
  
              // reset UI immediately
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
  
              return; // ❌ STOP FETCH COMPLETELY
            }
  
            const items = [];
            let errorData = null;
  
            this.fbtProducts.forEach(row => {
              const addedInput = row.dataset.added === 'true';
              if (!row.checked || addedInput) return;
  
              const rowVariantId = parseInt(row.value);
              const rowBeingAdded = 1;
              const maxLimit = parseFloat(row.getAttribute('data-max')) || 0;
              const alreadyInCart = parseFloat(row.getAttribute('data-cart')) || 0;
              const variantTitle = row.getAttribute('data-title');
  
              if ((rowBeingAdded + alreadyInCart) > maxLimit) {
                this.handleErrorMessage(
                  `Only ${maxLimit} ${variantTitle} available. You already have ${alreadyInCart} in cart.`
                );
                return;
              }
  
              items.push({
                id: rowVariantId,
                quantity: rowBeingAdded
              });
            });
  
  
            items.push({
              id: mainVariantId,
              quantity: mainQty
            });
  
            const payload = {
              items: items
            };
  
            if (this.cart) {
              payload.sections = this.cart.getSectionsToRender().map(s => s.id);
              payload.sections_url = window.location.pathname;
              this.cart.setActiveElement(document.activeElement);
            }
  
            // Final config for POST request
            config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
              body: JSON.stringify(payload)
            };
            // custom code ends
          }
        }

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showErrorPopup(response.description || response.message);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description );
              // this.newErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              this.triggerFlyToCartAnimation();
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            setTimeout(() => {
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            }, 800);
          })
          .catch((e) => {
            console.error(e);
          })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
          refreshFbtProductWrapper();
        });
      }
      // --- Error Popup Function ---
      showErrorPopup(message) {
        const popup = document.getElementById('CustomErrorModal');
        const textElement = document.getElementById('CustomErrorMessage');
        
        if (popup && textElement) {
          textElement.textContent = message;
          popup.style.display = 'flex';

          // Button aur Icon ko popup ke andar dhoondna
          const closeIcon = popup.querySelector('.close-modal');
          const okButton = popup.querySelector('.error-popup-content-wrapper button');

          if (closeIcon) {
            closeIcon.onclick = () => {
              popup.style.display = 'none';
            };
          }

          if (okButton) {
            okButton.onclick = () => {
              popup.style.display = 'none';
            };
          }
        } else {
          alert(message);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// Check if the element is already defined to avoid "already declared" errors
if (!customElements.get('fly-to-cart')) {
  
  // We define the class inside the block or assign it to a variable
  const FlyToCart = class extends HTMLElement {
    /** @type {Element} */
    source;

    /** @type {Element} */
    destination;

    connectedCallback() {
      this.#animate();
    }

    #animate() {
      const rect = this.getBoundingClientRect();
      const sourceRect = this.source.getBoundingClientRect();
      const destinationRect = this.destination.getBoundingClientRect();

      const offset = {
        x: rect.width / 2,
        y: rect.height / 2,
      };
      
      const startPoint = {
        x: sourceRect.left + sourceRect.width / 2 - offset.x,
        y: sourceRect.top + sourceRect.height / 2 - offset.y,
      };

      const endPoint = {
        x: destinationRect.left + destinationRect.width / 2 - offset.x,
        y: destinationRect.top + destinationRect.height / 2 - offset.y,
      };

      const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
      const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

      let startTime = null;
      const duration = 600;

      this.style.opacity = '1';

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

        this.style.setProperty('--x', `${position.x}px`);
        this.style.setProperty('--y', `${position.y}px`);

        const scale = 1 - progress * 0.5;
        this.style.setProperty('--scale', `${scale}`);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.style.opacity = '0';
          // Ensure onAnimationEnd is defined in your global scope
          if (typeof onAnimationEnd === 'function') {
            onAnimationEnd(this, () => this.remove());
          } else {
            this.remove();
          }
        }
      };

      this.style.setProperty('--x', `${startPoint.x}px`);
      this.style.setProperty('--y', `${startPoint.y}px`);

      requestAnimationFrame(animate);
    }
  };

  customElements.define('fly-to-cart', FlyToCart);
}

  // Move helper functions outside or keep them if they don't cause conflicts
  function bezierPoint(t, p0, p1, p2, p3) {
    const cX = 3 * (p1.x - p0.x);
    const bX = 3 * (p2.x - p1.x) - cX;
    const aX = p3.x - p0.x - cX - bX;

    const cY = 3 * (p1.y - p0.y);
    const bY = 3 * (p2.y - p1.y) - cY;
    const aY = p3.y - p0.y - cY - bY;

    const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
    const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

    return { x, y };
}